<template>
  <div class="app_container">
    <main-header :title="this.$route.name"></main-header>
    <div id="main">
      <transition name="fade">
      <div class="loader" v-if="show_loader"><img :src="loader_src" /></div>
      </transition>
      <div class="content">
        <transition name="slide" mode="out-in">
          <router-view @hideLoader="hideLoader"></router-view>
        </transition> 
      </div>
      <modal :showmodal="show_modal" @hideModal="hideModal"></modal>
    </div>
    <main-footer @showModal="showModal"></main-footer>
  </div>
</template>

<script>
import MainHeader from './components/Header'
import MainFooter from './components/Footer'
import Modal from './components/Modal'
import Loader from './components/Loader'
import loader_gif from './assets/img/gif_loader.gif';

export default {
  name: 'app',
  components: {
    MainHeader,
    MainFooter,
    Modal,
    Loader
  },
  data () {
    return {
      loader_src: loader_gif,
      show_modal: false,
      show_loader: true
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(to);
      this.show_loader = true;
    }
  },
  methods: {
    showModal (value) {
      this.show_modal = !this.show_modal;
    },
    hideModal (value) {
      this.show_modal = false;
    },
    hideLoader () {
      this.show_loader = false;
    },
    checkBrowser () {
      // Opera 8.0+
      var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      if(isOpera) document.body.classList.add("opera");
      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';
      if(isFirefox) document.body.classList.add("firefox");
      // Safari 3.0+ "[object HTMLElementConstructor]" 
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
      if(isSafari) document.body.classList.add("safari");
      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;
      if(isIE) document.body.classList.add("ie");
      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;
      if(isEdge) document.body.classList.add("edge");
      // Chrome 1+
      var isChrome = !!window.chrome && !!window.chrome.webstore;
      if(isChrome) document.body.classList.add("chrome");

      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;
    }
  },
  mounted: function() {
    this.show_loader = false;
    this.checkBrowser();
  },
  updated: function() {
    // this.show_loader = false;
  }

}
</script>

<style lang="scss">
  @import "~styles/style";
</style>



// WEBPACK FOOTER //
// App.vue?0e7cb2a8